import * as ko from 'knockout';

import { session } from '../session';

ko.bindingHandlers['tenantHref'] = {
  init: (element: Element, valueAccessor: () => KnockoutObservable<string>) => {
    const clickHandler = (event: Event) => {
      // in case token expires and user clicks on the link, we need to refresh the token
      // before the link is opened, in case of standard api request it is done already
      // but in case of external links we need to do it here
      const target = element.getAttribute('target');

      // For _blank targets, we need to handle the navigation manually
      if (target === '_blank') {
        event.preventDefault();
        session.getToken(true).then((token) => {
          document.cookie = `firebaseToken=${token}; path=/; SameSite=Strict; secure`;
          element.setAttribute('href', session.toTenantPath(ko.unwrap(valueAccessor())));
          window.open(element.getAttribute('href')!, '_blank');
        });
      }
    };

    element.addEventListener('click', clickHandler);
  },

  update: (element: Element, valueAccessor: () => KnockoutObservable<string>) => {
    const href = ko.unwrap(valueAccessor());
    element.setAttribute('href', session.toTenantPath(href));
  },
};
